export default __webpack_public_path__ + "static/media/support-notes-main-iproup.173a007a.png";